import React from 'react';
import ContactForm from './ContactForm';
import './Contact.css';

const Contact = () => {
    return (
        <section className="contact-section">
            <div className="contact-container">
                <div className="section-header">
                    <span>CONTACT US</span>
                    <h2>Get in Touch with Atlantic Primary Care</h2>
                </div>
                <div className="section-description">
                    <p>We're here to help you with your healthcare needs. Whether you have questions about appointments, need to reach our medical team, or want to learn more about our services, we're just a call or message away.</p>
                </div>
                
                <div className="contact-content">
                    <div className="contact-form-container">
                        <ContactForm />
                    </div>
                    
                    <div className="office-location">
                        <span>Our Location</span>
                        <h2 id="hanover">Hanover Office</h2>
                        <div className="office-details">
                            <div>
                                <div className="office-hours">
                                    <span>Hours</span>
                                    <p>Monday, Wednesday & Friday: 9:00 AM - 6:00 PM</p>
                                    <p>Tuesday & Thursday: 9:00 AM - 5:00 PM</p>
                                </div>
                                <div className="contact-info">
                                    <span>Location</span>
                                    <p>
                                        <a href="https://maps.app.goo.gl/n1FBhxoD8u51u4aX8" target="_blank" rel="noopener noreferrer">
                                            105 Webster St Suite 9, Hanover, MA 02339
                                        </a>
                                    </p>
                                </div>
                            </div>
                            <div className="map-container">
                                <iframe 
                                    title="hanovermap" 
                                    src="https://www.google.com/maps?q=105+Webster+St+Suite+9,+Hanover,+MA+02339&output=embed" 
                                    width="600" 
                                    height="450" 
                                    allowFullScreen="" 
                                    loading="lazy" 
                                    referrerPolicy="no-referrer-when-downgrade">
                                </iframe>
                            </div>
                        </div>
                    </div>

                    {/* Weymouth office section commented out for future use */}
                    {/* <div className="office-location">
                        <span>Our Locations</span>
                        <h2 id="weymouth">Weymouth Office</h2>
                        <div className="office-details">
                            <div>
                                <div className="office-hours">
                                    <span>Hours</span>
                                    <p>Thursday: 9:00 AM - 5:00 PM</p>
                                </div>
                                <div className="contact-info">
                                    <span>Location</span>
                                    <p>
                                        <a href="https://maps.app.goo.gl/9MMucpuUm9Szo2vu6" target="_blank" rel="noopener noreferrer">
                                            851 Main St Suite 25, Weymouth, MA 02190
                                        </a>
                                    </p>
                                </div>
                            </div>
                            <div className="map-container">
                                <iframe 
                                    title="weymouthmap" 
                                    src="https://www.google.com/maps?q=851+Main+St+Suite+25,+Weymouth,+MA+02190&output=embed" 
                                    width="600" 
                                    height="450" 
                                    allowFullScreen="" 
                                    loading="lazy" 
                                    referrerPolicy="no-referrer-when-downgrade">
                                </iframe>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </section>
    );
};

export default Contact;
